import React from 'react';
import { Typography, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { useParameterizedQuery, useMutation } from 'react-fetching-library';
import { getDocuments, sendDocument, sendSetOfDocumentsAction, sendOrderMail, refreshOrderDocumentAction } from '../../../../../../services/request';
import AgreementButton from './AgreementButton';
import PDFPreviewModal from './PDFPreviewModal';
import SendMessagePreviewModal from './SendMessagePreviewModal';
import toast from 'react-hot-toast';
import { ConfirmDialog } from '../../../../../../components/ConfirmDialog';

const WRDocumentsButtons = () => {
  const [openPreviewModal, setOpenPreviewModal] = React.useState(false);
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [documentTypeToRefresh, setDocumentTypeToRefresh] = React.useState(null);
  const { module, seasonIdentifier } = useSelector(state => state.app);
  const { order } = useSelector(state => state.orderData);
  const { mutate } = useMutation(sendDocument);
  const { mutate: refreshDocumentMutate } = useMutation(refreshOrderDocumentAction);
  const { query } = useParameterizedQuery(getDocuments);
  const { query: sendAllQuery } = useParameterizedQuery(sendSetOfDocumentsAction);

  const handleClick = async (template_name, fileName, annex_id = 0, preview = false) => {
    const { payload, error, loading } = await query(order.id, template_name, annex_id);
    if (!error && !loading) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${fileName}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    }
  };

  const handleConfirmRefresh = async documentType => {
    const { error, loading } = await refreshDocumentMutate(order.id, documentType);

    if (error) {
      toast.error('Nie udało się odświeżyć dokumentu');
    }
    if (!error && !loading) {
      toast.success('Dokument został odświeżony');
    }
    setOpenModal(false);

  };

  const handleSendAll = async data => {
    const { error, loading } = await sendAllQuery(order.id, data);
    if (!error && !loading) {
      toast.success('Komplet dokumentów został wysłany');
      setOpenPreviewModal(false);
    }

    if (error) {
      toast.error('Nie udało się wysłać kompletu dokumentów');
    }
  };


  const handleOpenPreviewModal = () => setOpenPreviewModal(true);
  const handleClosePreviewModal = () => setOpenPreviewModal(false);

  const attachmentFileNames = [
    order.agreement_number,
    ['l_23', 'l_24'].includes(seasonIdentifier) ? 'Karta kwalifikacyjna' : null,
    'Warunk uczestnictwa',
    'Klauzule inf.odo do umowy_organizacja wypoczynku_SunSport'
  ].filter(Boolean);

  return (
    <Grid container spacing={2} p={4}>
      <>
        <Grid item xs={12} sm={4} md={2}>
          <AgreementButton order={order} getDocument={handleClick} module={module}/>
        </Grid>
      </>


      {/* Modale i dialogi */}
      {previewUrl !== null && (
        <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)} />
      )}
      {openPreviewModal && (
        <SendMessagePreviewModal
          handleSend={handleSendAll}
          handleClose={handleClosePreviewModal}
          fileNames={attachmentFileNames}
          type="SSOD"
        />
      )}
      <ConfirmDialog
        title={'Odśwież dokument'}
        children={
          <Typography>
            Czy na pewno chcesz zresetować dokument? Obecne dane zostaną bezpowrotnie utracone. Akcja spowoduje automatyczną wysyłkę e-maila z linkiem do karty
          </Typography>
        }
        open={openModal}
        setOpen={setOpenModal}
        onConfirm={() => handleConfirmRefresh(documentTypeToRefresh)}
      />
    </Grid>

  );
};


export default WRDocumentsButtons;
